// TagLibraryManager.jsx
export const addItem = ({ inputValue, setInputValue, setListItems }) => {
    if (inputValue.trim()) {
        setListItems(prevItems => [...prevItems, { id: Date.now(), text: inputValue }]);
        setInputValue('');
    }
};

export const editItem = ({ id, newText, listItems, setListItems, rows, setRows, columns }) => {
    setListItems(prevItems =>
        prevItems.map(item => (item.id === id ? { ...item, text: newText } : item))
    );

    // Update selected tags in table rows
    setRows(prevRows =>
        prevRows.map(row => {
            const updatedRow = { ...row };
            columns.forEach(col => {
                const selectedKey = `column${col.id}_selected`;
                if (updatedRow[selectedKey]?.includes(listItems.find(item => item.id === id)?.text)) {
                    updatedRow[selectedKey] = updatedRow[selectedKey].map(tag =>
                        tag === listItems.find(item => item.id === id)?.text ? newText : tag
                    );
                }
            });
            return updatedRow;
        })
    );
};

export const deleteItem = ({ id, setListItems }) => {
    setListItems(prevItems => prevItems.filter(item => item.id !== id));
};
